import React from 'react';
import PropTypes from 'prop-types';

import {
  FieldStyled,
  InputStyled,
  LabelStyled,
  IconStyled,
} from './Checkbox.styled';

import { LabelSecondaryStyled } from '../shared';

export const checkboxSize = {
  XSMALL: 'xsmall',
  SMALL: 'small',
  DEFAULT: 'default',
  MEDIUM: 'medium',
};

export const checkboxLabelsAlignment = {
  START: 'start',
  END: 'end',
  JUSTIFY: 'justify',
};

function Checkbox({
  className,
  id,
  label,
  labelSecondary,
  labelsAlignment,
  value,
  onChange,
  size,
  disabled,
  checked,
  dataTestId,
}) {
  return (
    <FieldStyled className={className} size={size}>
      <InputStyled
        type='checkbox'
        id={id}
        data-testid={dataTestId}
        disabled={!!disabled}
        value={value}
        onChange={onChange}
        checked={checked}
      />
      <LabelStyled htmlFor={id} labelsAlignment={labelsAlignment}>
        <IconStyled name='check' customStroke='bold' />
        {label}
        {labelSecondary && (
          <LabelSecondaryStyled>{labelSecondary}</LabelSecondaryStyled>
        )}
      </LabelStyled>
    </FieldStyled>
  );
}

Checkbox.defaultProps = {
  size: checkboxSize.DEFAULT,
  checked: false,
};

Checkbox.propTypes = {
  className: PropTypes.string,
  /**
   * The id assigned to input field
   */
  id: PropTypes.string,
  /**
   * Text to show for the radio select
   */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * Secondary text to show content
   */
  labelSecondary: PropTypes.string,
  /**
   * This prop will change the arrangement of the label and secondaryLabel if exists
   */
  labelsAlignment: PropTypes.oneOf(Object.values(checkboxLabelsAlignment)),
  value: PropTypes.string,
  /**
   * Function handler for change event
   */
  onChange: PropTypes.func,
  size: PropTypes.oneOf(Object.values(checkboxSize)),
  /**
   * If true, will show the radio button disabled
   */
  disabled: PropTypes.bool,
  /**
   * Component checked status
   */
  checked: PropTypes.bool,
  /**
   * Data test id
   */
  dataTestId: PropTypes.string,
};

export default Checkbox;
